<template>
  <div class="content">
    <h1 class="title">{{ $t("partners.title") }}</h1>
    <div class="table">
      <table-list-users
        v-if="!isLoading"
        :headerList="tableHeaders"
        :userList="partners"
        :seenAttrs="userSeenAttrs"
        :userLogo="getPartnersLogo"
        userType="partners"
        @buttonClicked="handleActionClicked"
        @userChanged="handleUserEdit"
        @userDelete="handleUserDelete"
      />
      <v-card v-else class="loading">
        <v-progress-circular
          v-if="isLoading"
          size="73.5"
          indeterminate
          class="loading-circle"
        ></v-progress-circular>
      </v-card>
    </div>
  </div>
</template>

<script>
import TableListUsers from "@/components/global/tableListComponents/TableListUsers";
import { mapActions } from "vuex";
import { useToast } from "vue-toastification";

const toast = useToast();

export default {
  name: "Partners",
  props: {},
  components: {
    TableListUsers,
  },
  data() {
    return {
      partners: [],
      userSeenAttrs: [
        "id",
        "logo_base64",
        "cover_image_base64",
        "par_name",
        "par_company_name",
        "par_address",
        "par_tax_number",
        "par_active",
        "par_description",
        "par_gps",
        "par_soldable_products_number",
      ],
      actions: [
        {
          icon: "mdi-edit",
          type: "edit",
        },
      ],
      isLoading: true,
    };
  },
  created() {
    this.emitter.on("userDeleteConfirm", this.handleUserDelete);
    this.getPartnerList();
  },
  methods: {
    ...mapActions({
      getPartners: "users/getPartners",
      getPartnersLogo: "users/getPartnersLogo",
      editPartner: "users/editPartner",
      deletePartner: "users/deletePartner",
    }),

    blobToBase64(blob) {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      return new Promise((resolve) => {
        reader.onloadend = () => {
          resolve(reader.result);
        };
      });
    },

    getPartnerList() {
      this.isLoading = true;
      this.getPartners()
        .then((response) => {
          this.partners = response.result;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    handleUserEdit(bodyFormData) {
      this.editPartner(bodyFormData)
        .then(() => {
          toast.success(this.$t("partners.toast.successEdit"));
          this.getPartnerList();
        })
        .catch(() => {});
    },
    handleUserDelete(user) {
      this.deletePartner(user)
        .then(() => {
          toast.success(this.$t("partners.toast.successDelete"));
          this.getPartnerList();
        })
        .catch(() => {});
    },
  },
  computed: {
    tableHeaders() {
      const headers = [
        {
          title: this.$t("partners.table.headers.id"),
          textAlign: "text-left",
          value: "id",
        },
        {
          title: this.$t("partners.table.headers.logo"),
          textAlign: "text-left",
          value: "logo",
        },
        {
          title: this.$t("partners.table.headers.coverImage"),
          textAlign: "text-left",
          value: "cover_image",
        },
        {
          title: this.$t("partners.table.headers.name"),
          textAlign: "text-left",
          value: "name",
        },
        {
          title: this.$t("partners.table.headers.company"),
          textAlign: "text-left",
          value: "company_name",
        },
        {
          title: this.$t("partners.table.headers.address"),
          textAlign: "text-left",
          value: "address",
        },
        {
          title: this.$t("partners.table.headers.vatNumber"),
          textAlign: "text-left",
          value: "tax_number",
        },
        {
          title: this.$t("partners.table.headers.active"),
          textAlign: "text-left",
          value: "active",
        },
        {
          title: this.$t("partners.table.headers.description"),
          textAlign: "text-left",
          value: "description",
        },
        {
          title: this.$t("partners.table.headers.gps"),
          textAlign: "text-left",
          value: "gps",
        },
        {
          title: this.$t("partners.table.headers.productNumber"),
          textAlign: "text-left",
          value: "product_number",
        },
        {
          title: this.$t("partners.table.headers.actions"),
          textAlign: "text-right",
          value: "actions",
        },
      ];
      return headers;
    },
  },
  beforeUnmount() {
    this.emitter.off("userDeleteConfirm", this.handleUserDelete);
  },
};
</script>

<style lang="scss" scoped></style>
